import { ToastOptions } from '../types/ToastOptions';

export const TOAST_DEFAULT_OPTIONS: ToastOptions = {
  duration: 5000,
};
